import { useAction, useMutation } from 'convex/react'
import { api } from '@convex/_generated/api'
import type { Doc, Id } from '@convex/_generated/dataModel'
import { SigningRegistrationForm } from './SigningRegistrationForm'
import { validateReviewPdf } from './signing-review-form'

export function ContractSigningRegistration({ row }: { row: Doc<'contract_packages'> }) {
  const inspect = useAction(api.contractregistration.inspect), register = useAction(api.contractregistration.register), uploadUrl = useMutation(api.contracts.uploadUrl)
  return <SigningRegistrationForm key={`${row._id}:${row.package_sha256}:${row.parties_sha256}:${row.handoff_request_key}`} row={row} services={{ inspect, register, upload: async file => {
    validateReviewPdf(file)
    const response = await fetch(await uploadUrl({ mode: row.mode ?? 'test' }), { method: 'POST', headers: { 'Content-Type': 'application/pdf' }, body: file })
    if (!response.ok) throw new Error('No se ha podido guardar el PDF original. Conserva el archivo y vuelve a comprobar este expediente.')
    return (await response.json()).storageId as Id<'_storage'>
  } }}/>
}
